export const TIPOLOGIE = [
  ["bnb", "B&B"], ["casa_vacanza", "Casa vacanza"], ["agriturismo", "Agriturismo"],
  ["affittacamere", "Affittacamere"], ["altro", "Altro"],
];
export const ESITI = [
  ["pending", "In attesa"], ["evaluating", "In valutazione"], ["single_service", "Ha scelto un servizio singolo"],
  ["yu_follow", "Cliente YU Follow"], ["not_interested", "Non interessato"],
];
export const PARTNER_TYPES = [
  ["web_agency", "Web agency"], ["fotografo", "Fotografo"], ["agenzia_immobiliare", "Agenzia immobiliare"], ["altro", "Altro"],
];
export const COMPENSO = {
  none: { label: "In attesa", color: "#5B554F", bg: "#F5F3EF" },
  accrued: { label: "Maturato (attesa 1° canone)", color: "#8A5A00", bg: "#FFF4D6" },
  to_pay: { label: "Da pagare", color: "#C8461A", bg: "#FDEEE7" },
  paid: { label: "Pagato", color: "#1F7A3E", bg: "#E3F4E8" },
  expired: { label: "Attribuzione scaduta", color: "#8A2E1C", bg: "#F8E1DC" },
  duplicate: { label: "Contatto già presente", color: "#5B554F", bg: "#EDEAE5" },
};

const lookup = (list) => (k) => (list.find(([v]) => v === k) || [k, k])[1];
export const tipologiaLabel = lookup(TIPOLOGIE);
export const esitoLabel = lookup(ESITI);
export const partnerTypeLabel = lookup(PARTNER_TYPES);

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(String(s).length === 10 ? `${s}T00:00:00` : (/[zZ+]/.test(String(s).slice(-6)) ? s : `${s}Z`));
  return isNaN(d) ? "—" : d.toLocaleDateString("it-IT");
};
export const fmtEur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export function CompensoPill({ status, testId }) {
  const c = COMPENSO[status] || COMPENSO.none;
  return (
    <span data-testid={testId} className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap"
      style={{ color: c.color, background: c.bg }}>{c.label}</span>
  );
}
